import type { Action } from '../types';

interface SpinnerState {
  show: boolean;
}

const initialState = { show: false };

export default function reducer(
  state: SpinnerState = initialState,
  action: Action<any>,
): SpinnerState {
  switch (action.type) {
    case 'spinner':
      return {...state, show: action.response};
    default:
      return state;
  }
}